import { render, h } from "preact";
import { App } from "./App";

window.addEventListener("load", () => {
    render(<App/>, document.getElementById("app")!);
});
